if($('.type-detail').length){
 //   if($('.admin-logged').length){
        if($('.variant-list').length>0){
          if ($('.variant-list').length > 0) {
            $('.p-info-wrapper').append('<div class="adminURL"><table></table></div>');
            var variantsData = shoptet.variantsSplit.necessaryVariantData;
            var paramSets = [];
            $('.variant-list').each(function () {
                var $select = $(this).find('select');
                var paramId = $select.attr('data-parameter-id');
                var paramName = $select.attr('data-parameter-name');
                var optionsData = [];
                $select.find('option').each(function () {
                    var val = $(this).val();
                    if (val) {
                        optionsData.push({
                            value: val,
                            text: $(this).text().trim()
                        });
                    }
                });
                if (optionsData.length === 1) {
                    $select.val(optionsData[0].value).trigger('change');
                }
    
                paramSets.push({
                    paramId: paramId,
                    paramName: paramName,
                    options: optionsData
                });
            });
            function generateVariantUrl() {
                var selectedOptions = [];
                var allSelected = true;
    
                $('.variant-list select').each(function () {
                    var selectedValue = $(this).val();
                    if (!selectedValue) {
                        allSelected = false;
                    }
                    selectedOptions.push({
                        paramId: $(this).attr('data-parameter-id'),
                        value: selectedValue
                    });
                });
    
                if (allSelected) {
                    var keyParts = selectedOptions.map(function (opt) {
                        return opt.paramId + '-' + opt.value;
                    });
                    var finalKey = keyParts.join('-');
    
                    if (variantsData[finalKey]) {
                        var data = variantsData[finalKey];
                        var location = window.location.href;
                        var urlVariant = location.split('?variantId')[0] + '?variantId=' + data.id;
                        var combinationText = selectedOptions.map(function (opt) {
                            var paramName = $(`select[data-parameter-id="${opt.paramId}"]`).attr('data-parameter-name');
                            var optionText = $(`select[data-parameter-id="${opt.paramId}"] option[value="${opt.value}"]`).text().trim();
                            return paramName + ' - ' + optionText;
                        }).join(' / ');
                        changeUrl(urlVariant);

                    }
                } else {
                    $('.adminURL table').empty();
                }
            }
            function changeUrl(newUrl) {
                history.pushState(null, null, newUrl);
            }

            $('.variant-list select').on('change', function () {
                generateVariantUrl();
               
            });
        }
      }
   // }
    $('.p-info-wrapper').append('<div class="codeEan"></div>')
    $('.codeEan').append($('.p-detail-inner-header .p-code').clone())
    function findPLUByCode(code, eanData) {        
        let foundItem = eanData.find(item => item.code === code);
        return foundItem ? foundItem.ean : null;
    }
    function processElements(eanData) {
        setTimeout(function(){
            $(".p-detail>.p-detail-inner>.p-detail-inner-header .p-code > span").not(".p-code-label").not(".no-display").each(function() {
                let code = $(this).text().trim();
                let ean = findPLUByCode(code, eanData);
                if (ean) {
                    if(!$('.variant-list').length){
                        if(!$('.supplierBox').length){
                            $('.p-info-wrapper .codeEan').append('<div class="supplierBox"><strong>EAN:</strong> '+ean+'</div>')
                        }
                    }
                    else{
                        $('.supplierBox').remove()
                        if(!$('.supplierBox').length){
                            $('.p-info-wrapper .codeEan').append('<div class="supplierBox"><strong>EAN:</strong> '+ean+'</div>')
                        }
                    }
                }
            });
        }, 20)
        
    }
    let storedData = sessionStorage.getItem("eanData");
    if (storedData) {
        let eanData = JSON.parse(storedData);
        $(document).ready(function() {
            processElements(eanData);
            
        })
        document.addEventListener('ShoptetSplitVariantParameterChange', function() {
            processElements(eanData);
        });
    } else {
        $.getJSON("/user/documents/ean.json?v"+new Date().getMinutes(), function(data) {
            sessionStorage.setItem("eanData", JSON.stringify(data));
            $(document).ready(function() {
                processElements(data);
            })
            document.addEventListener('ShoptetSplitVariantParameterChange', function() {
                processElements(data);
            });
        });
    }


    $(".availability-value .availability-label").each(function() {
        $(this).html(function(){
          return $(this).html().replace("Zvolte variantu", "Dle varianty");
        })
    })
    $('.delivery-time').each(function() {
        $(this).html(function(){
          return $(this).html().replace("Zvolte variantu", "Dle varianty");
        })
    })
    if($('.variant-list').length>0){
        $('.p-info-wrapper .availability-label').each(function() {
            var obsah = $(this).text().trim();
            if (obsah === "Na dotaz" || obsah === "Na otázku") {
                $('.sold-out').hide();
                $('.p-final-price-wrapper').hide();
                $('.add-to-cart').hide();
                if(!$('.p-info-wrapper .kosik').length){
                    $('.p-info-wrapper').append('<div class="kosik"></div>');
                    $('.kosik').append($('a.link-icon.chat').clone());
                }
            }
            else{
                if(!$('.p-info-wrapper .kosik').length){
                    $('.p-info-wrapper').append('<div class="availRow"></div><div class="kosik"></div>')
                }
            }
        });        
    }
    else{
        if($('.p-info-wrapper .availability-label').text().trim() === 'Na dotaz' || $('.p-info-wrapper .availability-label').text().trim() === 'Na otázku'){
            $('.sold-out').hide();
            $('.p-final-price-wrapper').hide();
            $('.p-info-wrapper').append('<div class="kosik"></div>');
            $('.kosik').append($('a.link-icon.chat').clone())
        }
        else{
            $('.p-info-wrapper').append('<div class="availRow"></div><div class="kosik"></div>')
        }
    }
    

    
    if($('.delivery-time').length){
        $('.delivery-time').closest('tr').hide();
        $('.availRow').append('<div class="deliveryDate">Můžeme doručit do: <strong>'+$('.delivery-time').html()+'</strong></div>')
        $('.availRow').append($('.delivery-time').closest('tr').find('.shipping-options'))
    }
    else{
        $('.availRow').append($('.shipping-options'))
        
    }
    $('.availRow').append($('.availability-value'))

    $('.basic-description table').wrap('<div class="overflow-table"></div>')
    $('.p-image-wrapper').append($('.product-top>div:not(".col-lg-6") .flags'))
    $('.p-info-wrapper').append($('.p-detail-inner-header h1').clone())

    $('.p-info-wrapper').append($('.p-detail-info').clone())
  
   
    $('.kosik').append($('.p-final-price-wrapper'))
    $('.kosik').append($('.add-to-cart'))
}